import React from "react";
import styles from "../styles/SummarySection.module.css";
import { useState, useRef } from "react";
import { Autocomplete } from "@react-google-maps/api";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import MapsComponent from "./MapsComponent";

function SummarySection({
    origin,
    destination,
    duration,
    distance,
    pickUpDate,
    pickUpTime,
    setOrigin,
    setDestination,
    formValues,
    setFormValues,
    setDuration,
    setDistance,
    directions,
    setDirections,
}) {
    // console.log(dateTime)
    const autocompleteOrigin = useRef(null);
    const autocompleteDestination = useRef(null);

    const handleDestinationSelect = (place) => {
        console.log(place);
        setDestination(place);
    };
    const handleOriginSelect = (place) => {
        console.log(place);
        setOrigin(place);
    };

    const londonBounds = {
        // The latitude and longitude bounds for Greater London
        // These can be adjusted as needed
        north: 51.693788,
        south: 51.276303,
        east: 0.334015,
        west: -0.510375,
    };

    const [isShow, setIsShow] = useState(false);
    const [mapShow, setMapShow] = useState(false);

    const handlemapshow = () => {
        setMapShow(!mapShow);
    };

    const handleshow = () => {
        setIsShow(!isShow);
        mapShow && setMapShow(!mapShow);
    };

    return (
        <div className={`${styles.SummaryContainer} `}>
            <div className="row">
                <div className="col-lg-6 mt-1">
                    <strong>From:</strong>{" "}
                    <span>{origin.formatted_address}</span>
                </div>
                <div className="col-lg-6 mt-1">
                    <strong>To:</strong>{" "}
                    <span>{destination.formatted_address}</span>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-6 mt-1">
                    <strong>Duration:</strong> <span>{duration}</span>{" "}
                    <span>({distance})</span>
                </div>
                <div className="col-lg-6 mt-1">
                    <strong>Date & Time:</strong>{" "}
                    <span>{`${pickUpDate} ${pickUpTime}`}</span>
                </div>
            </div>
            <div className="row mt-1">
                <div className="col-lg-6 mt-1">
                    <strong>
                        <span
                            onClick={handleshow}
                            style={{ color: "#b68b47", cursor: "pointer" }}
                        >
                            Edit
                        </span>
                    </strong>
                </div>
                <div className="col-lg-6 mt-1">
                    <strong>
                        <span
                            onClick={handlemapshow}
                            style={{ color: "#b68b47", cursor: "pointer" }}
                        >
                            Show Map
                        </span>
                    </strong>
                </div>
            </div>
            {/* form coming up */}
            {isShow && (
                <>
                    <div className="row mt-1">
                        <h3
                            className={`${styles.changeBooking} text-center text-uppercase border-bottom mt-1`}
                        >
                            Change Booking Details
                        </h3>
                        <div className="col-lg-6">
                            <div className={styles.inputWrapper}>
                                <label className={`${styles.formLabel}`}>
                                    Where from?
                                </label>
                                <br />
                                <img
                                    src="images/location-icon.png"
                                    className={styles.inputIcon}
                                    alt="location icon"
                                />
                                <Autocomplete
                                    onLoad={(autocomplete) =>
                                        (autocompleteOrigin.current =
                                            autocomplete)
                                    }
                                    onPlaceChanged={() =>
                                        handleOriginSelect(
                                            autocompleteOrigin.current.getPlace()
                                        )
                                    }
                                    options={{
                                        bounds: londonBounds,
                                        componentRestrictions: {
                                            country: "uk",
                                        },
                                    }}
                                >
                                    <input
                                        type="text"
                                        placeholder="Enter Location"
                                        className={styles.formInput}
                                    />
                                </Autocomplete>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className={styles.inputWrapper}>
                                <label className={`${styles.formLabel}`}>
                                    Where to?
                                </label>
                                <br />
                                <img
                                    src="images/location-icon.png"
                                    className={styles.inputIcon}
                                    alt="location icon"
                                />
                                <Autocomplete
                                    onLoad={(autocomplete) =>
                                        (autocompleteDestination.current =
                                            autocomplete)
                                    }
                                    onPlaceChanged={() =>
                                        handleDestinationSelect(
                                            autocompleteDestination.current.getPlace()
                                        )
                                    }
                                    options={{
                                        bounds: londonBounds,
                                        componentRestrictions: {
                                            country: "uk",
                                        },
                                    }}
                                >
                                    <input
                                        type="text"
                                        className={styles.formInput}
                                        placeholder="Enter Destination Address"
                                    />
                                </Autocomplete>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-1">
                        <div className="col-lg-6">
                            <div className={styles.inputWrapper}>
                                <label className={`${styles.formLabel}`}>
                                    Pickup Date:
                                </label>
                                <br />
                                <DatePicker
                                    className={`${styles.formInput1}`}
                                    selected={formValues.Cal_Date}
                                    onChange={(date) => {
                                        console.log("Date selected", date);
                                        setFormValues({
                                            ...formValues,
                                            Cal_Date: date,
                                            pickUpDate: date.toDateString(),
                                        });
                                    }}
                                    minDate={new Date()}
                                    locale="en"
                                    showDateSelect
                                    dateFormat="MM/dd/yyyy"
                                    closeOnScroll={(e) => e.target === document}
                                    required
                                />
                                <br />
                            </div>
                        </div>
                        <div className="col-lg-6 mt-1">
                            <label className={`${styles.formLabel}`}>
                                Pickup Time :
                            </label>
                            <br />
                            <DatePicker
                                className={styles.formInput1}
                                selected={formValues.Cal_Time}
                                onChange={(date) => {
                                    console.log(
                                        "time selected:",
                                        date.toLocaleTimeString()
                                    );
                                    setFormValues({
                                        ...formValues,
                                        Cal_Time: date,
                                        pickUpTime: date.toLocaleTimeString(),
                                    });
                                }}
                                showTimeSelect
                                showTimeSelectOnly
                                timeIntervals={15}
                                timeCaption="Time"
                                dateFormat="h:mm aa"
                            />
                        </div>
                    </div>
                </>
            )}
            {(isShow || mapShow) && (
                <div className="mt-3">
                    <MapsComponent
                        origin={origin}
                        destination={destination}
                        setDirections={setDirections}
                        directions={directions}
                        setDistance={setDistance}
                        setDuration={setDuration}
                    />
                </div>
            )}
        </div>
    );
}

export default SummarySection;
